import { font as m } from '@moonbase-machines/charset';
export const { FONT } = m;